import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={{
          padding: 'var(--spacing-xl)',
          textAlign: 'center',
          color: 'var(--color-error)',
          backgroundColor: 'var(--color-background)',
          border: '2px solid var(--color-error)',
          margin: 'var(--spacing-lg)',
        }}>
          <h2 style={{
            fontFamily: 'var(--font-header)',
            fontSize: '1rem',
            marginBottom: 'var(--spacing-md)',
          }}>
            出现错误 / Something went wrong
          </h2>
          <p style={{ marginBottom: 'var(--spacing-lg)' }}>
            页面遇到了一个意外错误。请刷新页面重试。
          </p>
          <p style={{ marginBottom: 'var(--spacing-lg)' }}>
            The page encountered an unexpected error. Please refresh and try again.
          </p>
          <button
            className="button"
            onClick={() => window.location.reload()}
            style={{ backgroundColor: 'var(--color-error)' }}
          >
            刷新页面 / Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}